export enum MetaTemplateCategory {
    Marketing      = 'MARKETING',
    Utility        = 'UTILITY',
    Authentication = 'AUTHENTICATION'
}
export const MetaTemplateCategorySelect = Object.entries(MetaTemplateCategory).map(([key, value]) => ({ name: key, value }))
export const MetaTemplateCategoryArray = Object.values(MetaTemplateCategory);

/**
 * Como cada categoria se apresenta na UI.
 *
 * Mora aqui, e não no componente, porque o selo é desenhado em dois lugares que não
 * compartilham runtime: o editor da ação (componente Vue `StatusBadge`) e o card do
 * nó no fluxograma (string de HTML montada para o Drawflow). Duas cópias divergiriam
 * na primeira troca de cor — e a cor de `MARKETING` é justamente a âncora visual do
 * aviso de encadeamento em janela de 24h.
 *
 * `tone` é um tom de `assets/css/badges.css`, que é global: a string do nó pode usar
 * `bdg-tone-*` direto. `amber` fica reservado para a saída padrão por tempo no
 * fluxograma, por isso Marketing usa `pink`.
 */
export interface SeloCategoriaTemplate {
    label: string;
    /** Tom de `assets/css/badges.css` (sem o prefixo `bdg-tone-`). */
    tone: string;
    icon: string;
    descricao: string;
}

export const SELO_CATEGORIA_TEMPLATE: Record<MetaTemplateCategory, SeloCategoriaTemplate> = {
    [MetaTemplateCategory.Marketing]: {
        label: 'Marketing',
        tone: 'pink',
        icon: 'ri-megaphone-line',
        descricao: 'Promocional. A Meta costuma barrar mais de um por número dentro de 24h.',
    },
    [MetaTemplateCategory.Utility]: {
        label: 'Utilidade',
        tone: 'blue',
        icon: 'ri-tools-fill',
        descricao: 'Transacional — confirmação, atualização de pedido, lembrete.',
    },
    [MetaTemplateCategory.Authentication]: {
        label: 'Autenticação',
        tone: 'violet',
        icon: 'ri-shield-keyhole-line',
        descricao: 'Código de verificação. Só aceita botão de copiar código.',
    },
};

/** Selo da categoria, tolerante a valor desconhecido (template importado, categoria nova da Meta). */
export const seloDaCategoria = (categoria?: string | null): SeloCategoriaTemplate | null =>
    (categoria && SELO_CATEGORIA_TEMPLATE[categoria as MetaTemplateCategory]) || null;
